import { Injectable } from '@angular/core';


@Injectable()
export class Globals {
  public authen: AuthenData;
  public screenWidth: string;
  private isMobileResolution: boolean;
  // public BaseApiUrl: string = 'https://uat.tpcc.co.th/api/';
  // public BaseApiUrl: string = 'http://10.211.55.3:4460/';
  public BaseApiUrl: string = 'https://websales.tpcc.co.th/api/';
  // public UrlSendMail: string = 'http://localhost:4201/pages/changepassword/';
  public menuList: any;
  public UrlSendMail: string = 'https://websales.tpcc.co.th/web/pages/changepassword/';
  public mediaType: any = {
    EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    PDF: 'application/pdf',
    HTML: 'text/html'
  };
  constructor() {
    if (window.localStorage.getItem('sidebar') !== null) {
      this.menuList = this.getCookie('sidebar').menus;
    }

    if (window.innerWidth < 768) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }

  public getIsMobileResolution(): boolean {
    return this.isMobileResolution;
  }

  public setMenuList() {
    this.menuList = this.getCookie('sidebar').menus;
  }
  public setCookie(key: string, value: any): any {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  public getCookie(key: string): any {
    return JSON.parse(window.localStorage.getItem(key));
  }
  public getPaymentUrl(bankCode: any) {
    let url = '';
    if (bankCode === 1) {
      url = 'Payment/ScbProcess.aspx';
    } else if (bankCode === 2) {
      url = 'Payment/KTBProcess.aspx';
    } else if (bankCode === 3) {
      url = 'Payment/KBankProcess.aspx';
    } else if (bankCode === 4) {
      url = 'Payment/BayProcess.aspx';
    } else if (bankCode === 5) {
      url = 'Payment/BBLProcess.aspx';
    }
    return this.BaseApiUrl + url;
  }

  onMobileChange(status: boolean) {
  }

  public checkWidth() {
    const width = window.innerWidth;
    if (width <= 768) {
        this.screenWidth = 'sm';
        this.onMobileChange(true);
    } else if (width > 768 && width <= 992) {
        this.screenWidth = 'md';
        this.onMobileChange(false);
    } else {
        this.screenWidth = 'lg';
        this.onMobileChange(false);
    }
}

  public downloadfile(bytes, fileName, format, contentType) {
    if (window.navigator.msSaveOrOpenBlob) {
      const blob = new Blob([bytes], {
        type: contentType
      });
      navigator.msSaveBlob(blob, fileName + '.' + format);
    } else {
      const blob = new Blob([bytes], {
        type: contentType
      });
      const fileURL = URL.createObjectURL(blob);

      if (contentType === 'application/pdf') {
        const a = document.createElement('a');
        a.href = 'javascript:void(0)';
        // a.target = '_blank';
        // a.download = fileName + '.' + format;

        a.onclick = () => {
          const v = window.open(fileURL, '_blank', 'fullscreen=yes');
          v.print();
        };


        document.body.appendChild(a);
        a.click();
      } else {
        const a = document.createElement('a');
        a.href = fileURL;
        a.target = '_blank';
        a.download = fileName + '.' + format;
        document.body.appendChild(a);
        a.click();
      }
    }
  }
}

export interface AuthenData {
  access_token: string;
  token_type: string;
  expires_in: string;
  refresh_token: string;
  userName: string;
  fullName: string;
  companyName: string;
  role: string;
}



// WEBPACK FOOTER //
// ./src/app/globals/globals.ts